/* eslint-disable */
import { OBJECTS_TYPE_OPTIONS } from '@/utils/configs/objectsTypesConfig';
import { NULL_SPEC_PARAMS, REQUIREMENT_UPDATE_KEYS } from './constants';

import { convertDataToDbView } from '@/utils/storeUtils';
import { convertDataFromMssk, convertDataFromKsi, convertDataFromKsiFeatures } from '@/utils/classesDataConvertUtils';
import { checkIsType } from '@/utils/createHelpers/prepareClasses';

import api from '@/api';

class CustomError extends Error {
  constructor({ status, text }) {
    super();

    this.custom_text = text;
    this.custom_status = status;
  }
}

function setNullObjectsContent() {
  let nullObjsContent = {};

  OBJECTS_TYPE_OPTIONS.forEach((obj) => {
    nullObjsContent[obj.value] = [];
  });

  return nullObjsContent;
}

// -------------------------------- New API helpers ----------------------------------
function convertClassItemData(obj) {
  return {
    name: obj.name,
    code: obj.code,
    description: obj.description ? obj.description : null,
    parent_id: obj.parentId,
    position: obj.position,
    classifier_id: obj.classifierId,
    classifiers_table_id: obj.classifierTableId,
    classifier_level_id: obj.classifierLevelId ? obj.classifierLevelId : null,
    characteristic: obj.characteristic,
    characteristic_type: obj.characteristicType ? obj.characteristicType : null,
    characteristic_values: obj.characteristicValues ? obj.characteristicValues : null,
    source: obj.source ? obj.source : null,
    source_link: obj.sourceLink ? obj.sourceLink : null,
    synchronized_ifc_sections_attributes: obj.ifc,
  };
}

async function writeClassesBranchToDb(root, arr, api) {
  const res = await api.external.classes.create(convertClassItemData(root));

  root.id = res.data.id;
  const childes = arr.filter((item) => item.parentCode === root.code);

  for (let i = 0; i < childes.length; i++) {
    childes[i].parentId = root.id;
    childes[i].position = i;
    if (childes[i].terminalNode) {
      const innerRes = await api.external.classes.create(convertClassItemData(childes[i]));

      childes[i].id = innerRes.data.id;

      continue;
    }
    await writeClassesBranchToDb(childes[i], arr, api);
  }
}

export default {
  state: {
    docObjectsContent: JSON.parse(JSON.stringify(setNullObjectsContent())),
    specParts: [],
    activeSpecPart: null,
    originalSpecText: '',
    specParams: JSON.parse(JSON.stringify(NULL_SPEC_PARAMS)),
    docPartClassifiers: [],

    /* --------- CLASSIFIERS DATA ----------------- */
    classifiers: {},
    currClassifierList: [],
    selectedClassifierList: [],
    attractedClassifierList: [],
    sharedClassifiers: {},

    selectedLinkedClassifierList: [],

    /* ---------New API classifiers data ------------- */
    rootClassifier: null,
    rootClassifiers: [],
    classifierTables: [],
    classifiersTables: {},
    classifierTableData: [],

    classesTableTrees: [],
    classifiersAi: [],

    formEditMode: null,

    schemaData: [],
    schemaItem: {},
    docText: '',
    docStatus: 'no-such-status',
    docSpecs: [],
    docSpecParts: [],
    markedDocParts: [],
    parentSpecs: [],

    measureUnits: [],

    expertSpecs: [],
    implementators: [],

    requirementsAi: {
      data: [],
      length: 0,
    },

    needToTextUpdate: false,
  },

  getters: {
    docObjectsContent: (state) => JSON.parse(JSON.stringify(state.docObjectsContent)),
    currSpecParts: (state) => state.specParts.map((i) => Object.assign({}, i)),
    currActiveSpecPart: (state) => state.activeSpecPart,
    currOriginalText: (state) => state.originalSpecText,
    currLastSpecPartNum: (state) => state.specParts.length - 1,
    currSchemaPart: (state) => state.specParts[0].schemaPart,
    currDocPartClassifiers: (state) => JSON.parse(JSON.stringify(state.docPartClassifiers)),

    /* --------- CLASSIFIERS DATA ----------------- */
    selectedClassifiers: (state) => state.selectedClassifierList.map((i) => Object.assign({}, i)),
    attractedClassifiers: (state) => state.attractedClassifierList.map((i) => Object.assign({}, i)),
    currClassifierList: (state) => JSON.parse(JSON.stringify(state.currClassifierList)),

    selectedLinkedClassifiers: (state) => state.selectedLinkedClassifierList.join(', '),

    /* ---------New API classifiers data ------------- */
    currRootClassifiers: (state) => state.rootClassifiers.map((i) => ({ ...i })),
    currRootClassifier: (state) => ({ ...state.rootClassifier }),
    currClassifierTables: (state) => state.classifierTables.map((i) => ({ ...i })),
    currClassifierTableData: (state) => state.classifierTableData.map((i) => ({ ...i })),
    sharedDocClassifiers: (state) => JSON.parse(JSON.stringify(state.sharedClassifiers)),

    classesTableTrees: (state) => state.classesTableTrees.map((i) => i),
    currAiClassifiers: (state) => state.classifiersAi.map((i) => Object.assign({}, i)),

    currFormEditMode: (state) => state.formEditMode,

    currSchemaData: (state) => state.schemaData.map((i) => ({ ...i })),
    currSchemaItem: (state) => ({ ...state.schemaItem }),

    currDocText: (state) => state.docText,
    currDocStatus: (state) => state.docStatus,
    currDocSpecs: (state) => state.docSpecs,
    currDocSpecParts: (state) => state.docSpecParts,
    markedDocParts: (state) => state.markedDocParts,
    parentDocSpecs: (state) => state.parentSpecs,

    currSpecParams: (state) => state.specParams,
    currElementsIds: (state) => state.specParams.elements_id,

    needToTextUpdate: (state) => state.needToTextUpdate,

    measureUnits: (state) =>
      state.measureUnits.map((i) => ({
        value: i.id,
        label: i.name,
      })),
    measureUnitsObj: (state) => {
      let obj = {};

      state.measureUnits.forEach((item) => {
        obj[item.id] = item.name;
      });

      return obj;
    },
    expertSpecs: (state) => JSON.parse(JSON.stringify(state.expertSpecs)),
    implemsList: (state) => state.implementators.map((i) => ({ ...i })),

    currAiRequirements: (state) =>
      state.requirementsAi.length ? state.requirementsAi.data.map((i) => ({ ...i })).sort((a, b) => a.pos - b.pos) : [],
  },

  mutations: {
    SET_DOC_OBJECT_CONTENT(state, { objName, contentArr }) {
      state.docObjectsContent[objName] = contentArr;
    },
    ADD_TEXT_TO_FIRST_PART(state, { text }) {
      let newText = state.specParts[0].text + `<br>` + text;

      state.specParts[0].text = newText;
    },
    CHANGE_SPEC_PART_TEXT(state, { num, text }) {
      state.specParts[num].text = text;
    },
    REMOVE_LAST_SPEC_PART(state) {
      state.specParts.pop();
    },
    REMOVE_SELECTED_SPEC_PART(state, num) {
      state.specParts.splice(num, 1);

      if (state.activeSpecPart === num) {
        state.activeSpecPart = null;
      } else if (state.activeSpecPart && state.activeSpecPart > num) {
        state.activeSpecPart -= 1;
      }
    },
    RESET_CURRENT_SPEC_DATA(state) {
      state.specParts = [];
      state.specParams = { ...JSON.parse(JSON.stringify(NULL_SPEC_PARAMS)) };
    },
    SET_ACTIVE_SPEC_PART(state, part) {
      state.activeSpecPart = part;
    },
    SET_ORIGINAL_TEXT(state, text) {
      state.originalSpecText = text;
    },

    SET_CURR_SPEC_PARAM(state, { param, value }) {
      state.specParams[param] = value;
    },
    CHANGE_CURRENT_SPEC_ARRAY_DATA(state, { param, action, data }) {
      switch (action) {
        case 'add':
          state.specParams[param].push(data.item);
          break;
        case 'add-part':
          state.specParams[param].push(data);
          break;
        case 'remove':
          state.specParams[param] = state.specParams[param].filter(
            (i) => i.code !== data.code && i.classifiers_table_id !== data.tableId
          );
          break;
      }
    },
    SET_DOC_PART_CLASSIFIERS(state, arr) {
      state.docPartClassifiers = arr.sort(function (a, b) {
        return a.ancestry.localeCompare(b.ancestry);
      });
    },

    /* --------- CLASSIFIERS DATA ----------------- */
    SET_CLASSIFIER_DATA(state, { name, data }) {
      state.classifiers[name] = data;
    },
    UPDATE_SELECTED_CLASSIFIERS_LIST(state, { action, params }) {
      let num = params.code
        ? +state.selectedClassifierList.findIndex(
            (i) => i.code === params.code && i.classifiers_table_id === params.tableId
          )
        : -1;
      switch (action) {
        case 'clean':
          state.selectedClassifierList = [];
          break;
        case 'add':
          if (state.selectedClassifierList.findIndex((i) => +i.id === +params.item.id) === -1) {
            let handledClass = params.item;
            handledClass.with_children = params.mode;
            state.selectedClassifierList.push(handledClass);
          }

          if (params.mode) {
            state.selectedClassifierList = state.selectedClassifierList.filter(
              (item) => !params.item.children_list.includes(+item.id)
            );
          }
          break;
        case 'remove':
          state.selectedClassifierList = state.selectedClassifierList.filter((i, k) => k !== num);
          break;
        case 'change':
          state.selectedClassifierList[num].with_children = !state.selectedClassifierList[num].with_children;
          state.selectedClassifierList = state.selectedClassifierList.filter(
            (i, k) =>
              String(i.id) === i.ancestry ||
              k === num ||
              !i.ancestry.split('/').includes(String(state.selectedClassifierList[num].id))
          );
          break;
        case 'share':
          state.selectedClassifierList[num][params.key] = params.value;
          break;
        case 'cleanShare':
          if ('allDoc' in state.selectedClassifierList[num]) {
            state.selectedClassifierList[num].allDoc = undefined;
          }
          if ('docPart' in state.selectedClassifierList[num]) {
            state.selectedClassifierList[num].docPart = undefined;
          }
          break;
        default:
          console.error(`Unknown action on selected classifiers: ${action}`);
      }
    },
    UPDATE_SELECTED_LINKED_CLASSIFIER_LIST(state, { action, params }) {
      switch (action) {
        case 'add':
          state.selectedLinkedClassifierList = params.map((i) => i.code);
          break;
        case 'clear':
          state.selectedLinkedClassifierList = params;
          break;
      }
    },
    UPDATE_ATTRACTED_CLASSIFIERS_LIST(state, { action, params }) {
      switch (action) {
        case 'add':
          if (state.attractedClassifierList.findIndex((i) => +i.id === +params.id) === -1) {
            state.attractedClassifierList.push({
              ...params,
              with_children: false,
              selected: true,
            });
          }
          break;
        case 'update':
          state.attractedClassifierList[params].selected = !state.attractedClassifierList[params].selected;
          break;
        case 'check':
          state.attractedClassifierList = state.attractedClassifierList.filter((item) =>
            item.children_list.some(
              (child) => state.selectedClassifierList.findIndex((select) => +select.id === +child) >= 0
            )
          );
          break;
        case 'clean':
          state.attractedClassifierList = [];
          break;
      }
    },

    UPDATE_SELECTED_CLASSIFIER(state, obj) {
      const ind = state.selectedClassifierList.findIndex((i) => i.id === obj.id);

      state.selectedClassifierList[ind] = obj;
    },
    UPDATE_SPEC_PARAMS(state, arr) {
      state.specParams.classifiers = arr;
    },
    SET_SHARED_CLASSIFIERS(state, obj) {
      Object.keys(obj).forEach((key) => {
        state.sharedClassifiers[key] = obj[key];
      });
    },
    REMOVE_CLASSIFIER_ON_DOC_SHARE(state, classifier) {
      const ind = state.selectedClassifierList.findIndex((item) => item.id === classifier.id);

      state.selectedClassifierList[ind].shared = undefined;
    },
    ADD_CLASSIFIER_TO_SHARE_OBJECT(state, { classifier, docPart }) {
      if (!classifier.shared) classifier.shared = [];
      classifier.shared.push(docPart);

      if (!(docPart in state.sharedClassifiers)) state.sharedClassifiers[docPart] = [];
      state.sharedClassifiers[docPart].push(classifier);
    },
    RESET_SHARED_CLASSIFIERS(state) {
      state.sharedClassifiers = {};
    },

    UPDATE_SHARED_CLASSIFIER(state, { docPart, id, withChildren }) {
      const ind = state.sharedClassifiers[docPart].findIndex((el) => el.id === id);
      const selected = state.selectedClassifierList.findIndex((el) => el.id === id);

      state.sharedClassifiers[docPart][ind].with_children = withChildren;
      state.selectedClassifierList[selected].with_children = withChildren;
    },

    SET_CURR_SPEC_FEATURES(state, arr) {
      state.specParams.features = arr;
    },

    /* ---------New API classifiers data ------------- */
    SET_ROOT_CLASSIFIERS(state, arr) {
      state.rootClassifiers = arr
        .filter((item) => !item.hidden)
        .sort((a, b) => {
          if (a.released_at < b.released_at) {
            return 1;
          }
          if (a.released_at > b.released_at) {
            return -1;
          }
          return 0;
        });
    },
    ADD_ROOT_CLASSIFIER(state, obj) {
      state.rootClassifiers.push(obj);
    },
    UPDATE_ROOT_CLASSIFIER(state, obj) {
      const num = state.rootClassifiers.findIndex((i) => i.id === obj.id);

      state.rootClassifiers.splice(num, 1, obj);
    },
    SET_ROOT_CLASSIFIER(state, obj) {
      state.rootClassifier = obj ? obj : null;
    },
    REMOVE_ROOT_CLASSIFIER(state, id) {
      const num = state.rootClassifiers.findIndex((i) => i.id === id);

      state.rootClassifiers.splice(num, 1);
    },
    SET_CLASSIFIER_TABLES(state, arr) {
      state.classifierTables = arr;
    },
    SET_CLASSIFIER_TABLE_DATA(state, arr) {
      state.classifierTableData = arr;
    },
    REMOVE_CLASSIFIER_TABLE(state, id) {
      const num = state.classifierTables.findIndex((i) => i.id === id);

      state.classifierTables.splice(num, 1);
    },
    SET_CURRENT_CLASSIFIERS_LIST(state, list) {
      state.currClassifierList = list;
    },

    SET_CLASSES_TABLE_TREES(state, arr) {
      state.classesTableTrees = arr;
    },
    REMOVE_CLASSES_TABLE_TREE(state, num) {
      state.classesTableTrees.splice(num, 1);
    },
    SET_AI_CLASSIFIERS(state, obj) {
      const arr = [];

      Object.keys(obj).forEach((classTable) => {
        Object.keys(obj[classTable]).forEach((method) => {
          obj[classTable][method].forEach((i) => {
            const classObj = i.data;

            classObj.confidence = i.confidence;
            classObj.classTable = classTable;
            classObj.method = method;

            arr.push(classObj);
          });
        });
      });

      state.classifiersAi = arr;
    },

    SET_EDIT_MODE(state, mode) {
      state.formEditMode = mode;
    },

    SET_SCHEMA_DATA(state, arr) {
      state.schemaData = arr.map((i) => i);
    },
    SET_SCHEMA_ITEM(state, obj) {
      state.schemaItem = { ...obj };
    },
    SET_DOC_TEXT(state, str) {
      state.docText = str;
    },

    SET_CURR_DOC_SPECS(state, arr) {
      state.docSpecs = arr;
    },
    SET_PARENT_DOC_SPECS(state, arr) {
      state.parentSpecs = arr;
    },
    ADD_SPEC_TO_DOC_SPECS(state, item) {
      state.docSpecs.push(item);
    },
    REMOVE_SPEC_FROM_DOC_SPECS(state, item) {
      let index = state.docSpecs.findIndex((i) => i.id === item.id);

      state.docSpecs.splice(index, 1);
    },

    SET_ITMO_DOC_STATUS(state, str) {
      state.docStatus = str;
    },
    ADD_SPEC_PART(state, part) {
      // Специальная обработка добавления примечания разработчика базы
      if (part.name === 'Примечание редактора базы') {
        let editorIndex = state.specParts.findIndex((i) => i.name === 'Примечание редактора базы');

        if (editorIndex !== -1) {
          state.specParts[editorIndex].text = part.text;

          return;
        }
      }
      state.specParts.push(part);
    },
    SET_MEASURE_UNITS(state, arr) {
      state.measureUnits = arr;
    },

    SET_EXPERT_DATA(state, arr) {
      state.expertSpecs = arr;
    },
    SET_IMPLEMENTATORS(state, arr) {
      state.implementators = arr;
    },
    ADD_IMPLEMENTATOR(state, obj) {
      state.implementators.push(obj);
    },
    EDIT_IMPLEMENTATOR(state, obj) {
      const index = state.implementators.findIndex((i) => i.id === obj.id);

      state.implementators.splice(index, 1, obj);
    },
    DELETE_IMPLEMENTATOR(state, id) {
      const index = state.implementators.findIndex((i) => i.id === id);

      state.implementators.splice(index, 1);
    },

    SET_AI_REQS_TOOLTIPS(state, arr) {
      state.requirementsAi.data = arr;
      state.requirementsAi['length'] = arr.length;
    },

    SET_DOC_TEXT_PARTS(state, arr) {
      const newArr = arr;
      arr.forEach((item) => (item.uniName = `${item.name}_${item.id}`));
      state.docSpecParts = newArr;
    },

    SET_MARKED_DOC_PARTS(state, arr) {
      state.markedDocParts = arr;
    },

    SET_TO_UPDATE(state, value) {
      state.needToTextUpdate = value;
    },
  },

  actions: {
    setDocObjectContent({ commit }, obj) {
      commit('SET_DOC_OBJECT_CONTENT', obj);
    },
    addTextToFirstPart({ commit }, { text }) {
      commit('ADD_TEXT_TO_FIRST_PART', {
        text: text,
      });
    },
    checkAndUpdateSpecPartText({ commit }, { num, text }) {
      commit('CHANGE_SPEC_PART_TEXT', {
        num: num,
        text: text,
      });
    },
    removeLastSpecPart({ state, commit }) {
      if (state.specParts.length === 1) return;
      commit('REMOVE_LAST_SPEC_PART');
    },
    removeSelectedSpecPart({ commit }, num) {
      commit('REMOVE_SELECTED_SPEC_PART', num);
    },
    resetCurrentSpecData({ commit }) {
      commit('RESET_CURRENT_SPEC_DATA');
    },
    changeArraySpecParam({ commit }, { param, action, data }) {
      commit('CHANGE_CURRENT_SPEC_ARRAY_DATA', {
        param: param,
        action: action,
        data: data,
      });
    },
    setActiveSpecPart({ commit }, part) {
      commit('SET_ACTIVE_SPEC_PART', part);
    },
    setOriginalText({ commit }, text) {
      commit('SET_ORIGINAL_TEXT', text);
    },

    /* --------- CLASSIFIERS DATA ----------------- */
    updateSelectedClassifiersList({ commit }, { action, params }) {
      commit('UPDATE_SELECTED_CLASSIFIERS_LIST', {
        action: action,
        params: params,
      });
    },
    resetClassifierSelectionData({ commit }) {
      commit('UPDATE_SELECTED_CLASSIFIERS_LIST', {
        action: 'clean',
        params: {},
      });
      commit('UPDATE_ATTRACTED_CLASSIFIERS_LIST', {
        action: 'clean',
        params: {},
      });
      commit('SET_CURRENT_CLASSIFIERS_LIST', []);
    },
    updateSelectedLinkedClassifierList({ commit }, { action, params }) {
      commit('UPDATE_SELECTED_LINKED_CLASSIFIER_LIST', {
        action: action,
        params: params,
      });
    },
    updateAddictedClassifiers({ commit }, { action, params }) {
      commit('UPDATE_ATTRACTED_CLASSIFIERS_LIST', {
        action: action,
        params: params,
      });
    },

    /* ---------New API classifiers data ------------- */
    async getRootClassifiers({ commit }) {
      try {
        const res = await api.external.classifiers.getAll();

        commit('SET_ROOT_CLASSIFIERS', res.data);
      } catch (err) {
        throw err;
      }
    },
    async saveRootClassifier({ commit }, obj) {
      obj.released_at = obj.released_at.toLocaleDateString('ru').split('.').reverse().join('-');
      try {
        const res = await api.external.classifiers.create(convertDataToDbView(obj));

        commit('ADD_ROOT_CLASSIFIER', res.data);
        commit('SET_ROOT_CLASSIFIER');
      } catch (err) {
        throw err;
      }
    },
    async updateRootClassifier({ state, commit }, obj) {
      obj.released_at = obj.released_at.toLocaleDateString('ru').split('.').reverse().join('-');
      try {
        const res = await api.external.classifiers.update({
          ...convertDataToDbView(obj),
          id: state.rootClassifier.id,
        });
        commit('UPDATE_ROOT_CLASSIFIER', res.data);
        commit('SET_ROOT_CLASSIFIER');
      } catch (err) {
        throw err;
      }
    },
    setRootClassifier({ commit }, obj) {
      commit('SET_ROOT_CLASSIFIER', obj);
    },
    async deleteRootClassifier({ commit }, id) {
      try {
        await api.external.classifiers.remove(id);
        commit('REMOVE_ROOT_CLASSIFIER', id);
      } catch (err) {
        console.error(`Error on going to delete classifier: ${id}`);

        throw err;
      }
    },
    async deleteClassifierTable({ commit }, id) {
      try {
        await api.external.classifiersTables.remove(id);
        commit('REMOVE_CLASSIFIER_TABLE', id);
      } catch (err) {
        console.error(`Error on going to delete classifier table: ${id}`);

        throw err;
      }
    },
    async getClassifierTables({ state, commit }) {
      try {
        const res = await api.external.classifiersTables.get(state.rootClassifier.id);
        const sortedRes = res.data.sort((a, b) => a.position - b.position);

        commit('SET_CLASSIFIER_TABLES', sortedRes);
      } catch (err) {
        throw err;
      }
    },
    setClassifierTables({ commit }, arr) {
      commit('SET_CLASSIFIER_TABLES', arr);
    },
    async loadClassifierTables({ state }) {
      try {
        const tables = state.classifierTables
          .sort((a, b) => a.id - b.id)
          .map((item, num) => {
            item.position = num;

            return convertDataToDbView(item);
          });
        await api.external.classifiersTables.create({
          classifier: state.rootClassifier.id,
          tables,
        });
      } catch (err) {
        throw err;
      }
    },
    async loadTableClassesToDb({ rootState, state, commit }, { mode, data, tableId, tableCode, isFeature }) {
      try {
        let trees = [];

        data.forEach((item) => {
          item.classifierId = state.rootClassifier.id;
          item.classifierTableId = tableId;
          //TODO: Add characteristic data here too
        });
        switch (mode) {
          case 'mssk':
            trees = convertDataFromMssk(data, tableCode, isFeature);
            break;
          case 'ksi':
            if (isFeature) {
              trees = convertDataFromKsiFeatures(data);
            } else {
              trees = convertDataFromKsi(data);
            }
            break;
          default:
            throw new Error(`Unknown classifier type: ${mode}`);
        }
        const treesLength = trees.reduce((acc, item) => acc + item.length, 0);

        if (treesLength < 1000) {
          for (let i = 0; i < trees.length; i++) {
            await writeClassesBranchToDb(trees[i][0], trees[i], rootState.apiParams);
          }
        } else {
          commit('SET_CLASSES_TABLE_TREES', trees);
        }
      } catch (err) {
        console.error(`Error on writing table to DB: ${err.message}`);
        throw err;
      }
    },
    async downloadClassesTree({ rootState, state, commit }, num) {
      try {
        await writeClassesBranchToDb(
          state.classesTableTrees[num][0],
          state.classesTableTrees[num],
          rootState.apiParams
        );
        commit('REMOVE_CLASSES_TABLE_TREE', num);
      } catch (err) {
        console.error(`Error on download tree ${num}`);
        throw err;
      }
    },
    cleanupClassesTrees({ commit }) {
      commit('SET_CLASSES_TABLE_TREES', []);
    },
    async getClassifierTableData({ rootState, commit }, obj) {
      try {
        const res = await api.external.classes.getByCode({
          classifier: obj.classifier_id,
          table: obj.code,
        });

        const reachedData = res.data;

        reachedData.forEach((item) => {
          let children = reachedData.filter((innerItem) => innerItem.parent_id === item.id);

          item.children_count = children.length;
        });
        commit('SET_CLASSIFIER_TABLE_DATA', reachedData);
      } catch (err) {
        console.error('Error on get classifier table data: ', err.message);
        throw err;
      }
    },
    setCommonTableLevel({ state, commit }, obj) {
      const levelClasses = state.classifierTableData
        .filter((i) => i.parent_id === (obj ? obj.id : null))
        .sort((a, b) => a.position - b.position);

      commit('SET_CURRENT_CLASSIFIERS_LIST', levelClasses);
    },
    searchCurrStr({ state, commit }, { targetStr }) {
      let resArr = state.classifierTableData.filter((item) => {
        let cond1 = item.name.toLowerCase().indexOf(targetStr.toLowerCase()) !== -1;
        let cond2 = item.code.toLowerCase().indexOf(targetStr.toLowerCase()) !== -1;

        return cond1 || cond2;
      });

      commit('SET_CURRENT_CLASSIFIERS_LIST', resArr);
    },
    async searchCurrDocPartClassifiers({ rootState, state, commit }, idArr) {
      try {
        const requirementIds = [];
        const classIds = [];
        const classesArr = [];

        for (let i = 0; i < idArr.length; i++) {
          // Получение всех требований, привязанных к выделенному разделу документа
          const res = await api.external.requirements.getBySection({
            id: rootState.docData.id,
            part_id: idArr[i],
          });

          res.data.forEach((item) => {
            requirementIds.push(item.id);
          });
        }

        for (let i = 0; i < requirementIds.length; i++) {
          // Получение всех схлопнутых классов по выбранному классификатору
          const specRes = await api.external.reqClasses.getLinked(requirementIds[i], {
            classifier_id: state.rootClassifier.id,
          });

          // Условие для записи класса
          for (let j = 0; j < specRes.data.length; j++) {
            // Если класс до этого не встречался
            if (classIds.indexOf(specRes.data[j].id) === -1) {
              // записываем класс в массив классов
              classesArr.push(specRes.data[j]);
              // записываем ID этого класса в отдельный проверочный массив
              classIds.push(specRes.data[j].id);
            }
          }
        }

        commit('SET_DOC_PART_CLASSIFIERS', classesArr);
      } catch (err) {
        console.error('Error on get classifiers on doc part: ', err.message);
        throw err;
      }
    },
    async linkAiClassifier({ rootState, state, commit }, { section, id, classTable, mode }) {
      try {
        const item = state.classifiersAi.find(
          (item) => item.section === section && item.id === id && item.classTable === classTable
        );
        const idClassTable =
          item.classTable === 'bic' ? `${rootState.classifierParams.KSI}` : `${rootState.classifierParams.MSSK}`;
        const classCode = item.id;

        const res = await api.external.classes.getByCode({
          classifier: idClassTable,
          table: item.section,
          code: classCode,
        });

        if (!res.data[0]) throw new Error('No such classifier code!');

        commit('UPDATE_SELECTED_CLASSIFIERS_LIST', {
          action: 'add',
          params: {
            item: res.data[0],
            mode: mode,
          },
        });
      } catch (err) {
        console.error(`Error on get AI tooltip classifier: `, err.message);

        throw err;
      }
    },

    setEditMode({ commit }, mode) {
      commit('SET_EDIT_MODE', mode ? mode : null);
    },

    async getCurrDocSchemaData({ rootState, commit }) {
      try {
        const res = await api.external.sections.getAll(rootState.docData.id);
        const inputArr = res.data.sections;
        const outputArr = [];

        function sortSchemaData(parentId) {
          let levelArr = inputArr.filter((i) => i.parent_id === parentId);

          levelArr.sort((a, b) => a.position - b.position);
          for (let i = 0; i < levelArr.length; i++) {
            if (levelArr[i].terminal_node) {
              outputArr.push(levelArr[i]);

              continue;
            }
            outputArr.push(levelArr[i]);
            sortSchemaData(levelArr[i].id);
          }
        }

        sortSchemaData(null);
        commit('SET_SCHEMA_DATA', outputArr);
      } catch (err) {
        throw err;
      }
    },
    async getCurrDocText({ rootState, commit }) {
      try {
        const res = await api.external.documents.getHTML(rootState.docData.id);

        commit('SET_DOC_TEXT', res.data.html);
      } catch (err) {
        throw err;
      }
    },

    async createNewSpec({ state, commit }, { schemaItem, elements }) {
      try {
        const res = await api.external.requirements.create({
          hidden: false,
          status: 'works',
          mandatory: false,
          voluntary: false,
          document_section_id: schemaItem.id,
          mandatory_documents: [],
          voluntary_documents: [],
          elements_id: elements,
          requirements_text_id: [],
        });

        commit('SET_SCHEMA_ITEM', schemaItem);

        Object.keys(res.data).forEach((key) => {
          commit('SET_CURR_SPEC_PARAM', {
            param: key,
            value: res.data[key],
          });
        });
        commit('ADD_SPEC_TO_DOC_SPECS', state.specParams);
      } catch (err) {
        throw err;
      }
    },
    setCurrSpecParam({ commit }, { param, value }) {
      commit('SET_CURR_SPEC_PARAM', {
        param: param,
        value: value,
      });
    },
    addSpecificationPart({ commit }, part) {
      commit('ADD_SPEC_PART', part);
    },
    setSchemaItem({ state, commit }, id) {
      const schemaItem = state.schemaData.find((i) => i.id === id);
      commit('SET_SCHEMA_ITEM', schemaItem);
    },
    async saveCurrSpecText({ rootState, commit, state }, cleanupSpecParts) {
      try {
        // Передача очищенного текста
        for (let i = 0; i < cleanupSpecParts.length; i++) {
          let partId = null;
          const parts = state.docSpecParts.filter((item) => item.uniName === cleanupSpecParts[i].uniName);
          const partObj = {
            name: cleanupSpecParts[i].name,
            description: cleanupSpecParts[i].text,
            document_id: rootState.docData.id,
          };

          if (!parts.length) {
            const res = await api.external.accordions.create(partObj);

            partId = res.data.id;
          } else {
            partId = parts[0].id;
            await api.external.accordions.update({
              ...partObj,
              id: partId,
            });
          }

          commit('CHANGE_CURRENT_SPEC_ARRAY_DATA', {
            param: 'requirements_text_ids',
            action: 'add-part',
            data: partId,
          });
        }
      } catch (err) {
        console.error('Error on write text parts to inner DB: ', err.message);

        throw err;
      }
    },

    async getDocSpecTexts({ rootState, commit }) {
      try {
        const res = await api.external.accordions.getAll({
          document_id: rootState.docData.id,
          with_name: true,
        });

        commit('SET_DOC_TEXT_PARTS', res.data);
      } catch (error) {
        console.error('Error with get spec tests: ', error.message);

        throw error;
      }
    },

    async saveSpecClasses({}, obj) {
      try {
        const res = await api.developer.reqs.classes({ requirements_classifiers_classes: obj });
      } catch (error) {
        console.error('Ошибка привязки классов! ', error);
        throw err;
      }
    },
    async getCurrDocSpecifications({ rootState, commit }) {
      try {
        // Получение всех требований, привязанных к документу
        const res = await api.external.requirements.getBySection({
          id: rootState.docData.id,
        });
        commit('SET_CURR_DOC_SPECS', res.data);
      } catch (err) {
        throw err;
      }
    },
    async getParentDocSpecifications({ commit }, id) {
      try {
        // Получение всех требований, привязанных к родительскому документу
        const res = await api.external.requirements.getBySection({ id });
        commit('SET_PARENT_DOC_SPECS', res.data);
      } catch (err) {
        commit('SET_PARENT_DOC_SPECS', []);
      }
    },

    // -----------------------------------------------------------------------------------------------------

    async getCurrDocSharedClassifiers({ rootState, commit, dispatch }) {
      try {
        const res = await api.external.docClasses.get({ id: rootState.docData.id });
        const resClasses = res.data.classes;
        const classesObj = {};
        const sharedObj = {};

        // Read data for all shared classifiers
        for (let i = 0; i < resClasses.length; i++) {
          const classId = resClasses[i].classifiers_class_id;
          const innerRes = await dispatch('getClassById', classId);

          if (!(classId in classesObj)) {
            classesObj[classId] = innerRes;
          }
          if (!('shared' in classesObj[classId])) classesObj[classId].shared = [];
          classesObj[classId].shared.push({
            shareId: resClasses[i].id,
            docPart: resClasses[i].document_part !== null ? resClasses[i].document_part : 'all_doc',
            withChildren: resClasses[i]['with_children'],
          });
        }

        // Create shared classifiers object
        resClasses.forEach((item) => {
          const shareKey = item.document_part !== null ? item.document_part : 'all_doc';

          if (!(shareKey in sharedObj)) sharedObj[shareKey] = [];
          sharedObj[shareKey].push(classesObj[item.classifiers_class_id]);
        });

        commit('SET_SHARED_CLASSIFIERS', sharedObj);
      } catch (err) {
        throw err;
      }
    },
    resetDocSharedClassifiers({ commit }) {
      commit('RESET_SHARED_CLASSIFIERS');
    },
    async setPreviouslySharedClassifiers({ state, commit, dispatch }) {
      let arr = [];
      let parts = ['all_doc'];

      // Создание массива индексов раздела документа для поиска
      // общих классификаторов
      if (state.schemaItem && state.schemaItem.section_index) {
        state.schemaItem.section_index.split('|').forEach((part, i, arr) => {
          parts.push(arr.slice(0, i + 1).join('|'));
        });
      }

      // Поиск среди общих классификаторов, классификаторов, привязанных
      // к элементам массива parts
      parts.forEach((part) => {
        if (part in state.sharedClassifiers) {
          // TODO: При удалении расшаренного класса проверять его удаление в sharedClassifiers
          arr = arr.concat(state.sharedClassifiers[part]).filter((i) => !!i.shared);

          arr.map((item) => {
            const currShare = item.shared.filter((i) => i.docPart === part);

            if (currShare.length) item['with_children'] = currShare[0].withChildren;

            return item;
          });
        }
      });

      for (let item of arr) {
        commit('UPDATE_SELECTED_CLASSIFIERS_LIST', {
          action: 'add',
          params: {
            item: item,
            mode: item['with_children'],
          },
        });

        if (checkIsType(item.code, item.classifiers_table.code)) {
          await dispatch('getParentClass', item.parent_id);
        }
      }
    },

    async removeShareOnDocPart({ commit }, { classifier, shareId, changeData }) {
      try {
        await api.external.docClasses.remove(shareId, {
          change_data: changeData ? 'true' : 'false',
        });
        commit('REMOVE_CLASSIFIER_ON_DOC_SHARE', classifier);
      } catch (err) {
        console.error('Error on share classifier: ', err.message);

        throw err;
      }
    },
    async addShareOnDocPart({ state, rootState, commit }, { classifier, docPart, changeData }) {
      let schemaItem;

      if (docPart === 'all_doc') {
        schemaItem = null;
      } else {
        schemaItem = state.schemaData.find((item) => item.section_index === docPart);
      }
      try {
        const res = await api.external.docClasses.create({
          classifiers_class_id: classifier.id,
          document_id: rootState.docData.id,
          document_section_id: schemaItem ? schemaItem.id : null,
          document_part: schemaItem ? schemaItem.section_index : null,
          change_data: changeData,
          with_children: classifier.with_children,
        });
        let newClassifier = { ...classifier };

        if (!newClassifier.shared) newClassifier.shared = [];
        newClassifier.shared.push({
          shareId: res.data.id,
          docPart: res.data.document_part !== null ? res.data.document_part : 'all_doc',
          withChildren: res.data['with_children'],
        });
        commit('UPDATE_SELECTED_CLASSIFIER', newClassifier);
        commit('ADD_CLASSIFIER_TO_SHARE_OBJECT', {
          classifier: newClassifier,
          docPart: docPart,
        });
      } catch (err) {
        console.error('Error on share classifier: ', err.message);
        throw err;
      }
    },

    async updateShareOnDocPart({ state, rootState, commit }, { classifier, docPart, shareId, changeData }) {
      let schemaItem;

      if (docPart === 'all_doc') {
        schemaItem = null;
      } else {
        schemaItem = state.schemaData.find((item) => item.section_index === docPart);
      }
      try {
        const res = await api.external.docClasses.update({
          classifiers_class_id: classifier.id,
          document_id: rootState.docData.id,
          document_section_id: schemaItem ? schemaItem.id : null,
          document_part: schemaItem ? schemaItem.section_index : null,
          change_data: changeData,
          with_children: !classifier.with_children,
          id: shareId,
        });

        commit('UPDATE_SHARED_CLASSIFIER', {
          docPart: docPart,
          id: classifier.id,
          withChildren: res.data['with_children'],
        });
      } catch (err) {
        console.error('Error on share classifier: ', err.message);
        throw err;
      }
    },

    async setSpecClassifiersToSee({ state, commit }) {
      try {
        const res = await api.developer.reqs.getClasses(state.specParams.id);
        const specClassesIds = res.data.classifiers_classes
          .filter((item) => !item.auto_selection)
          .map((item) => item.classifiers_class_id);
        const classes = await api.developer.classes.getInfo({
          ids: specClassesIds,
        });
        commit('UPDATE_SPEC_PARAMS', classes.data.classifiers_classes);
      } catch (err) {
        throw err;
      }
    },

    async getParentClass({ commit, dispatch }, id) {
      try {
        const res = await dispatch('getClassById', id);

        commit('UPDATE_ATTRACTED_CLASSIFIERS_LIST', {
          action: 'add',
          params: res,
        });
      } catch (error) {
        throw err;
      }
    },

    async getClassById({}, id) {
      try {
        const res = await api.external.classes.getById(id);
        return res.data;
      } catch (error) {
        throw err;
      }
    },

    async updateSpecParams({ state, commit }, obj) {
      const preparedSpecObj = Object.assign(state.specParams, obj);
      const objToUpdateSpec = {};

      REQUIREMENT_UPDATE_KEYS.forEach((key) => {
        objToUpdateSpec[key] = preparedSpecObj[key];
      });
      try {
        await api.external.requirements.update({
          ...objToUpdateSpec,
          id: state.specParams.id,
        });
        Object.keys(obj).forEach((key) => {
          commit('SET_CURR_SPEC_PARAM', {
            param: key,
            value: obj[key],
          });
        });
      } catch (err) {
        throw err;
      }
    },

    async updateOldSpecParams({}, { id, arr, sectionId }) {
      try {
        await api.external.requirements.update({
          requirements_relations_attributes: arr,
          document_section_id: sectionId,
          id,
        });
      } catch (err) {
        throw err;
      }
    },

    async deleteCurrSpec({ state, commit }) {
      if (!state.specParams.id) return;

      try {
        await api.external.requirements.remove(state.specParams.id);
        commit('REMOVE_SPEC_FROM_DOC_SPECS', state.specParams);
      } catch (err) {
        console.error(`Error on going to delete spec: ${err.message}`);
        throw err;
      }
    },

    async getMeasureUnits({ commit }) {
      try {
        const res = await api.external.features.getUnits();

        commit('SET_MEASURE_UNITS', res.data);
      } catch (err) {
        throw err;
      }
    },
    async saveFeature({ dispatch }, data) {
      try {
        for (let i = 0; i < data.classifiersJumpClassId.length; i++) {
          const currData = JSON.parse(JSON.stringify(data));
          currData.classifiersJumpClassId = data.classifiersJumpClassId[i];

          await api.external.reqFeatures.create(convertDataToDbView(currData));
        }

        await dispatch('getCurrSpecFeatures');
      } catch (err) {
        console.log(`Error on write characteristic: ${err.message}`);
        throw err;
      }
    },
    async editFeature({ dispatch }, { id, data }) {
      try {
        await api.external.reqFeatures.update({
          ...convertDataToDbView(data),
          id,
        });
        await dispatch('getCurrSpecFeatures');
      } catch (err) {
        console.log(`Error on write characteristic: ${err.message}`);
        throw err;
      }
    },
    async deleteFeatureValue({ dispatch }, featureId) {
      try {
        await api.external.reqFeatures.remove(featureId.id);
        await dispatch('getCurrSpecFeatures');
      } catch (err) {
        console.log(`Error on delete characteristic: ${err.message}`);
        throw err;
      }
    },
    async getCurrSpecFeatures({ state, commit }) {
      try {
        const res = await api.external.reqFeatures.get(state.specParams.id);
        commit('SET_CURR_SPEC_FEATURES', res.data);
      } catch (err) {
        console.log(`Error on get characteristic: ${err.message}`);
        throw err;
      }
    },

    async setImplementators({ commit }) {
      try {
        const res = await api.external.implementators.getAll();
        commit('SET_IMPLEMENTATORS', res.data);
      } catch (err) {
        console.log(`Error on get implementators: ${err.message}`);
        throw err;
      }
    },
    async createImplementator({ commit }, { developer, developerLink }) {
      try {
        const res = await api.external.implementators.create({
          developer: developer,
          developer_link: developerLink ? developerLink : null,
        });
        commit('ADD_IMPLEMENTATOR', res.data);
        return res.data.id;
      } catch (err) {
        console.log(`Error on create implementators: ${err.message}`);
        throw err;
      }
    },
    async editImplementator({ commit }, { id, developer, developerLink }) {
      try {
        const res = await api.external.implementators.update({
          developer: developer,
          developer_link: developerLink ? developerLink : null,
          id,
        });

        commit('EDIT_IMPLEMENTATOR', res.data);

        return res.data.id;
      } catch (err) {
        console.log(`Error on update implementators: ${err.message}`);
        throw err;
      }
    },
    async deleteImplementator({ commit }, id) {
      try {
        await api.external.implementators.remove(id);

        commit('DELETE_IMPLEMENTATOR', id);
      } catch (err) {
        console.log(`Error on delete implementators: ${err.message}`);
        throw err;
      }
    },
    setMarkedDocParts({ commit }, arr) {
      commit('SET_MARKED_DOC_PARTS', arr);
    },
    setToUpdate({ commit }, value) {
      commit('SET_TO_UPDATE', value);
    },

    // -------------------------------------------------------------------------------------------------------------------------
    // --------------------------------------   ITMO HANDLING -------------------------------------------------------------------

    getItmoDocStatus({ commit }, { status }) {
      commit('SET_ITMO_DOC_STATUS', status);
    },
    resetItmoStatus({ commit }) {
      commit('SET_ITMO_DOC_STATUS', 'no-such-status');
    },
    reserAiTooltips({ commit }) {
      commit('SET_AI_CLASSIFIERS', []);
    },

    async getAiTooltips({ commit }, aiTooltips) {
      commit('SET_AI_CLASSIFIERS', aiTooltips);
    },

    async resetSegmentationData({ commit }) {
      commit('SET_AI_REQS_TOOLTIPS', []);
    },
    async getSegmentationData({ commit }, segments) {
      commit('SET_AI_REQS_TOOLTIPS', segments);
    },
    // -------------------------------------------------------------------------------------------------------------------------
  },
};
